import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import type { APIResponse } from "@/lib/types";

export type WorkflowInvitation = { connectionId: string; passcode: string };
export const retrieveWorkflowInvitations = async (
  path: string,
  matterId?: string,
) => {
  const response = await authenticatedFastApiAxiosInstance.get<
    APIResponse<WorkflowInvitation[]>
  >(`${path}/invitations`, {
    params: { matterId },
    headers: { "Cache-Control": "no-store" },
  });
  return response.data.data;
};
